import TableButton from "../../../Components/Buttons/TableButton";
import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";
import Table from "../../../Components/Table/Table";
import { Tooltip } from "react-tooltip";

export default function ProfitTable({ rows, accLoading, onWithdraw }) {
  return (
    <div className="w-full flex flex-col gap-5">
      <Table
        isEnglish={[2]}
        columns={[
          { key: "uuid", label: "کد حساب" },
          { key: "accountType", label: "نوع حساب" },
          { key: "accountProfit", label: "سود حساب" },
          { key: "profitAvailable", label: "سود قابل برداشت" },
          { key: "processTime", label: "زمان تقریبی پردازش" },
          {
            key: "operation",
            label: "برداشت سود",
            render: (value, row) => {
              const tooltipId = `payoutLockReasonTooltip-${row.id}`;

              if (row.isLocked) {
                return (
                  <div
                    data-tooltip-id={tooltipId}
                    data-tooltip-content={row.lockReason}
                    className="w-full flex items-center justify-center gap-2 cursor-default"
                  >
                    <SVG
                      name="lock"
                      classname="size-5 stroke-zi-text-light dark:stroke-zi-text-dark"
                    />
                    <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
                      علت
                    </span>
                    <Tooltip
                      id={tooltipId}
                      place="bottom"
                      className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-cyan-600 !rounded-lg"
                    />
                  </div>
                );
              }

              return (
                <TableButton
                  text="درخواست برداشت"
                  svg_name=""
                  svgClassName="size-5 stroke-zi-text-light dark:stroke-zi-text-dark"
                  href=""
                  className="!gap-0 !py-1.5 !px-3 !font-thin !w-fit !rounded-md text-zi-text-dark hocus:opacity-85 bg-zi-buttonbg-primary"
                  onClick={() => onWithdraw(row)}
                />
              );
            },
          },
        ]}
        data={rows}
      />

      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {!accLoading && rows.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            حساب فاندد جهت برداشت سود ندارید
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
